import axios from "axios";

// Only use for read-only endpoints. Never retry withdrawals or coupon issuance.
export async function postCashbackRead(url, body, config) {
  try {
    return await axios.post(url, body, config);
  } catch (error) {
    const status = error?.response?.status;
    if (config?.signal?.aborted || axios.isCancel?.(error) || (status && ![502, 504].includes(status))) throw error;
    return axios.post(url, body, config);
  }
}
